import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Produit } from 'app/models/produit';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { ProduitsService } from 'app/services/produits/produits.service';
import { AwscontrolService, UploadResponse, DeleteResponse } from 'app/services/aws/awscontrol.service'; // Import the service
import { FormControl, Validators } from '@angular/forms';
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { Location } from '@angular/common';

@Component({
  selector: 'app-ajouter-cafe-resto',
  templateUrl: './ajouter-cafe-resto.component.html',
  styleUrls: ['./ajouter-cafe-resto.component.scss']
})
export class AjouterCafeRestoComponent implements OnInit {
  @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;

  // Form controls
  numCommercialFormControl: FormControl;
  emailCommercialFormControl: FormControl;
  videoUrlInput: FormControl;
  
  // Data
  produit: Produit;
  public produits: any;
  public materiaux: any;
  agenciesApp: any;
  
  // File upload
  selectedFiles: FileList;
  fileNames: string[] = [];
  nameErrorMessage: string = '';
  
  // Images
  public image!: string;
  public imagePromo!: string;
  mainImages: string[] = [];
  promoImage: string = '';
  
  // Agency
  idAgency: any;
  NameAgence: any;

  constructor(
    private router: Router,
    private agenciesService: AgenciesService,
    private produitService: ProduitsService,
    private awsService: AwscontrolService, // Inject AWS service
    private location: Location
  ) { 
    this.produit = new Produit();
    
    // Form controls initialization
    this.numCommercialFormControl = new FormControl('', [
      Validators.pattern('^[0-9]{8}$')
    ]);
    
    this.emailCommercialFormControl = new FormControl('', [
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]);
    
    this.videoUrlInput = new FormControl('', [
      Validators.pattern('^https?://')
    ]);
  }

  ngOnInit(): void {
    this.getData();
    this.idAgency = this.agenciesService.getIdAgency();
    console.log('idAgency in OtherComponent:', this.idAgency);
    this.AgencyNameById();
  }

  // Formatage du texte dans la description
  formatText(command: string): void {
    if (this.descriptionTextarea) {
      const textarea = this.descriptionTextarea.nativeElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.produit.description ? this.produit.description.substring(start, end) : '';
      
      let formattedText = '';
      let newText = this.produit.description || '';
      
      switch (command) {
        case 'bold':
          formattedText = `<strong>${selectedText}</strong>`;
          break;
        case 'italic':
          formattedText = `<em>${selectedText}</em>`;
          break;
        case 'underline':
          formattedText = `<u>${selectedText}</u>`;
          break;
        case 'paragraph':
          formattedText = `<p>${selectedText}</p>`;
          break;
        case 'list':
          const lines = selectedText.split('\n');
          formattedText = '<ul>\n' + lines.map(line => `  <li>${line}</li>`).join('\n') + '\n</ul>';
          break;
      }
      
      newText = newText.substring(0, start) + formattedText + newText.substring(end);
      this.produit.description = newText;
      
      // Set focus back to textarea
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
      }, 0);
    }
  }

  // Generate random string for file names
  public getRandomString(length: number): string {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  // Upload main images using the new service
  uploadimg2(): void {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      // Convert FileList to array
      const filesArray: File[] = [];
      for (let i = 0; i < this.selectedFiles.length; i++) {
        filesArray.push(this.selectedFiles[i]);
      }
      
      this.uploadFilesimg2(filesArray);
    }
  }

  selectFileimg(e: any): void {
    this.selectedFiles = e.target.files;
    this.uploadimg2();
  }

  // Upload multiple files using the service
  uploadFilesimg2(files: File[]): void {
    // Generate unique file names
    const renamedFiles = files.map(file => {
      const newName = `produit-images/${this.getRandomString(5)}_${file.name}`;
      return new File([file], newName, { type: file.type });
    });

    this.awsService.uploadFiles(renamedFiles, 'produit-images').subscribe({
      next: (response: UploadResponse) => {
        if (response.success) {
          console.log('Images uploaded:', response.urls);
          
          // Add all uploaded URLs to main images array
          response.urls.forEach(url => {
            this.mainImages.push(url);
          });
          
          // Add file names
          files.forEach(file => {
            this.fileNames.push(file.name);
          });
          
          // Store in localStorage (first image only)
          if (this.mainImages.length > 0) {
            localStorage.setItem('prodImg', JSON.stringify(this.mainImages[0]));
          }
          
          Swal.fire({
            icon: "success",
            title: "Images ajoutées",
            text: `${response.count} image(s) téléchargée(s) avec succès`,
            timer: 1500,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur de téléchargement",
            text: response.error || "Échec du téléchargement des images",
          });
        }
      },
      error: (err: any) => {
        console.error('Error uploading images:', err);
        Swal.fire({
          icon: "error",
          title: "Erreur de téléchargement",
          text: "Échec du téléchargement des images. Veuillez réessayer.",
        });
      }
    });
  }

  // Remove main image using the service
  removeMainImage(index: number): void {
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer cette image?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        const imageUrl = this.mainImages[index];
        
        // Delete from S3
        this.awsService.deleteFile(imageUrl).subscribe({
          next: (response: DeleteResponse) => {
            if (response.status === 'success') {
              // Remove from arrays
              this.mainImages.splice(index, 1);
              this.fileNames.splice(index, 1);
              
              // Update localStorage if first image was removed
              if (this.mainImages.length > 0) {
                localStorage.setItem('prodImg', JSON.stringify(this.mainImages[0]));
              } else {
                localStorage.removeItem('prodImg');
              }
              
              Swal.fire({
                icon: "success",
                title: "Image supprimée",
                text: "L'image a été supprimée avec succès",
                timer: 1500,
                showConfirmButton: false
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: response.error || "Échec de la suppression de l'image",
              });
            }
          },
          error: (err: any) => {
            console.error('Error deleting image:', err);
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Échec de la suppression de l'image. Veuillez réessayer.",
            });
          }
        });
      }
    });
  }

  // Upload promo image using the service
  uploadimgPromo(): void {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      const file = this.selectedFiles[0];
      this.uploadFileimgPromo(file);
    }
  }

  selectFileimgPromo(e: any): void {
    this.selectedFiles = e.target.files;
    this.uploadimgPromo();
  }

  uploadFileimgPromo(file: File): void {
    // Generate unique file name
    const renamedFile = new File([file], `produit-promo-images/${this.getRandomString(5)}_${file.name}`, { 
      type: file.type 
    });

    this.awsService.uploadFile(renamedFile, 'produit-promo-images').subscribe({
      next: (response: UploadResponse) => {
        if (response.success && response.urls.length > 0) {
          console.log('Promo image uploaded:', response.urls[0]);
          
          // Set promo image
          this.promoImage = response.urls[0];
          
          // Store in localStorage
          localStorage.setItem('promoImg', JSON.stringify(this.promoImage));
          
          Swal.fire({
            icon: "success",
            title: "Image promotionnelle ajoutée",
            text: "L'image promotionnelle a été téléchargée avec succès",
            timer: 1500,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur de téléchargement",
            text: response.error || "Échec du téléchargement de l'image promotionnelle",
          });
        }
      },
      error: (err: any) => {
        console.error('Error uploading promo image:', err);
        Swal.fire({
          icon: "error",
          title: "Erreur de téléchargement",
          text: "Échec du téléchargement de l'image promotionnelle.",
        });
      }
    });
  }

  // Remove promo image using the service
  removePromoImage(): void {
    if (!this.promoImage) return;

    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer l'image promotionnelle?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        // Delete from S3
        this.awsService.deleteFile(this.promoImage).subscribe({
          next: (response: DeleteResponse) => {
            if (response.status === 'success') {
              this.promoImage = '';
              localStorage.removeItem('promoImg');
              
              Swal.fire({
                icon: "success",
                title: "Image supprimée",
                text: "L'image promotionnelle a été supprimée avec succès",
                timer: 1500,
                showConfirmButton: false
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: response.error || "Échec de la suppression de l'image",
              });
            }
          },
          error: (err: any) => {
            console.error('Error deleting promo image:', err);
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Échec de la suppression de l'image. Veuillez réessayer.",
            });
          }
        });
      }
    });
  }

  // Get data
  getData(): void {
    this.getAllAgencies();
    this.agenciesService.getListMateriaux().subscribe((data) => {
      this.materiaux = data;
    });
  }

  getAllAgencies(): void {
    this.agenciesService.getList().subscribe((data) => {
      this.agenciesApp = data;
    });
  }

  AgencyNameById(): void {
    setTimeout(() => {
      this.agenciesService.getAgencieById(this.idAgency).subscribe((data: any) => {
        this.NameAgence = data?.name;
        console.log(this.NameAgence);
      });
    });
  }

  // File input change (kept for compatibility)
  csvInputChange(fileInputEvent: any): void {
    console.log(fileInputEvent.target.files[0]);
  }

  csvInputtChange(fileInputEvent: any): void {
    console.log(fileInputEvent.target.files[0]);
  }

  // Form validation
  validateForm(): boolean {
    let isValid = true;

    // Validation pour le champ "name"
    if (!this.produit.name) {
      this.nameErrorMessage = 'Le nom est requis !';
      isValid = false;
    } else {
      this.nameErrorMessage = '';
    }

    return isValid;
  }

  // Validate YouTube URL
  validateVideoUrl(): boolean {
    if (!this.produit.videoUrlProduit) return true; // Optional field
    
    const youtubeUrlPattern = /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubeUrlPattern.test(this.produit.videoUrlProduit);
  }

  // Form submission
  onSubmit(): void {
    // Validation
    if (!this.validateForm()) {
      return;
    }

    if (!this.produit.name || !this.produit.description || !this.NameAgence) {
      Swal.fire({
        icon: 'warning',
        title: 'Champs requis',
        text: 'Veuillez remplir tous les champs obligatoires (Nom, Description, Agence)'
      });
      return;
    }

    if (this.produit.videoUrlProduit && !this.validateVideoUrl()) {
      Swal.fire({
        icon: 'error',
        title: 'URL YouTube invalide',
        text: 'Veuillez entrer une URL YouTube valide'
      });
      return;
    }

    // Use first main image or null
    const mainImageUrl = this.mainImages.length > 0 ? this.mainImages[0] : null;

    this.produits = {
      "name": this.produit.name,
      "status": this.produit.status,
      "description": this.produit.description,
      "prix": this.produit.prix,  
      "agencyName": this.NameAgence,   
      "categoryList": this.produit.categoryList,  
      "imageUrl": mainImageUrl,   
      "promoTitle": this.produit.promoTitle,  
      "videoUrlProduit": this.produit.videoUrlProduit,  
      "nomCommercial": this.produit.nomCommercial,  
      "numCommercial": this.produit.numCommercial,  
      "emailCommercial": this.produit.emailCommercial,  
      "promoImg": this.promoImage
    };

    console.log('Data to submit:', this.produits);

    this.produitService.createProduit(this.produits).subscribe(
      () => {  
        console.log("Success");
        
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Le produit a été créé avec succès",
        }).then(() => {
          // Clear localStorage
          localStorage.removeItem('prodImg');
          localStorage.removeItem('promoImg');
          
          setTimeout(() => {
            this.getData();
          }, 500);
          this.navigateBack();
        });
      },
      (error: HttpErrorResponse) => {
        console.error('Error creating product:', error);
        
        if (error.error && error.error.message) {
          if (error.error.message.includes('Cannot invoke "String.toLowerCase()"')) {
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Veuillez remplir correctement le formulaire",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: error.error.message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Échec de la création du produit. Veuillez réessayer.",
          });
        }
      }
    );
  }

  navigateBack(): void {
    this.location.back();
  }
}